module.exports = __webpack_public_path__ + "media/images/riders/EMILY_BATTY-9183ae8d67f7ecb6fbab9ad3fdcf8ee9.png";